import React, { useState, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import DashBoard from "./components/Dashboard/DashBoard";
import HomePage from "./components/HomePage";
import Login from "./components/Login";
// Dashboard/Home is hidden — route commented out below.
// import Home from "./components/Home/Home";
import MyApps from "./components/MyApps/MyApps";
import EmailContact from "./components/EmailContact";
import Contact from "./components/Contact";
import AdContact from "./components/AdContact.js";
import Ref from "./components/Ref";
import Source from "./components/Source";
import MarketPlace from "./components/MarketPlace/MarketPlace";
import MyAppDetail from "./components/MyApps/MyAppsDetail.js";
// MailBox is hidden — route commented out below.
// import MailBox from "./components/MailBox/MailBox.js";
import AllUsers from "./components/AllUsers/AllUsers.js";
import Invite from "./components/Invite/Invite";
import App1 from "./App1.js";
import AcceptInvite from "./components/Profile/AcceptInvite";
import WebsiteApps from "./components/Website_Apps/WebsiteApps.js";
import TaxonomyPage from "./components/Taxonomy/TaxonomyPage";
import { isAdmin } from "./utils/sectionPermissions";
import Vendors from "./components/Vendors/Vendors";
import ProductApprovals from "./components/ProductApproval/ProductApprovals";
import CatalogProposals from "./components/Catalog/CatalogProposals";
import DuplicateShelves from "./components/Catalog/DuplicateShelves";
import AdminProducts from "./components/AdminProducts/AdminProducts.js";
import OrderApprovals from "./components/OrderApprovals/Orders.js";
import IngramFailedOrders from "./components/OrderApprovals/IngramFailedOrders.js";
import IngramMapping from "./components/IngramMapping/IngramMapping.js";
import TrackingDetails from "./components/OrderApprovals/TrackingDetails/TrackingDetails.js";
import {
  NewsletterListPage,
  NewsletterEditorPage,
  WorkspaceMonthlyDigestPage,
} from "./components/Newsletters";
import {
  BlogStudioPage,
  BlogDraftEditorPage,
} from "./components/BlogStudio";
import EmailAnalytics from "./components/EmailAnalytics/EmailAnalytics.js";
import RenewalReminders from "./components/RenewalReminders/RenewalReminders.js";
import WarmLeads from "./components/WarmLeads/WarmLeads.js";
import InboundFunnel from "./components/InboundFunnel/InboundFunnel.js";
import ComparePages from "./components/ComparePages/ComparePages.js";
import RevenueTracker from "./components/RevenueTracker/RevenueTracker.js";
import ZohoBilling from "./components/ZohoBilling/ZohoBilling.js";
import DomainExtractor from "./components/DomainExtractor/DomainExtractor.js";
import Hrms from "./components/Hrms/Hrms.js";

const App = () => {
  const [user, setUser] = useState("");
  const socket = useRef();
  const [userRole, setUserRole] = useState({});
  // Top-level role string ("super_admin" | "admin" | "member") so child
  // routes can render super-admin-only controls without re-fetching.
  const [role, setRole] = useState("");
  const value = (user) => {
    setUser(user);
  };
  return (
    <>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/app1" element={<App1 />} />
        <Route exact path="/login" element={<Login User={value} />} />
        <Route exact path="/acceptInvite/:token" element={<AcceptInvite />} />
        <Route
          path="dashboard"
          element={
            <DashBoard
              user={user}
              User={value}
              socket={socket}
              userRole={userRole}
              setUserRole={setUserRole}
              role={role}
              setAppRole={setRole}
            />
          }
        >
          <Route
            path="marketplace"
            element={<MarketPlace user={user} userRole={userRole} />}
          />
          <Route
            path="adminproducts"
            element={<AdminProducts user={user} userRole={userRole} />}
          />
          {/* Rebuilt queue + review screen. Two routes so a submission is a
              real URL — the old screen swapped page state, so refresh or back
              lost your place and a review could not be linked to anyone. */}
          <Route path="productapproval" element={isAdmin(userRole) ? <ProductApprovals /> : null} />
          <Route path="productapproval/:approvalId" element={isAdmin(userRole) ? <ProductApprovals /> : null} />
          {/* Multi-vendor catalogue governance: the vendor asks (names,
              plans, periods) and the legacy duplicate shelves the phase-1
              backfill refused to merge on its own. Admin-only for the same
              reason approvals are — these decisions apply to every vendor on
              the shelf. */}
          <Route path="catalog_proposals" element={isAdmin(userRole) ? <CatalogProposals /> : null} />
          <Route path="catalog_duplicates" element={isAdmin(userRole) ? <DuplicateShelves /> : null} />
          {/* Approvals + Vendors stay admin-only regardless of any section a
              member holds (vendor bank + margin data, publish rights) — same
              gate the old ProductApproval screen had. */}
          {/* Vendors — the supplier side. Two routes so a vendor is a real
              URL you can link to, unlike the approvals screen which swaps
              page state and loses your place on refresh. */}
          <Route path="vendors" element={isAdmin(userRole) ? <Vendors /> : null} />
          <Route path="vendors/:vendorId" element={isAdmin(userRole) ? <Vendors /> : null} />
          <Route path="invite" element={<Invite />} />
          <Route path="myapps" element={<MyApps userRole={userRole} role={role} />} />
          <Route path="myapps/:productName" element={<MyAppDetail role={role} />} />
          <Route path="renewal_reminders" element={<RenewalReminders />} />
          <Route path="warm_leads" element={<WarmLeads />} />
          <Route path="inbound_funnel" element={<InboundFunnel />} />
          <Route path="compare_pages" element={<ComparePages />} />
          <Route path="revenue" element={<RevenueTracker />} />
          <Route path="zoho_billing" element={<ZohoBilling />} />
          <Route path="domain_extractor" element={<DomainExtractor />} />
          <Route path="hrms" element={<Hrms />} />
          <Route path="allusers" element={<AllUsers userRole={userRole} />} />
          <Route
            path="email_contact"
            element={<EmailContact userRole={userRole} />}
          />
          {/* <Route path="mail_box" element={<MailBox userRole={userRole} />} /> */}
          <Route path="contact" element={<Contact userRole={userRole} />} />
          <Route path="adcontact" element={<AdContact userRole={userRole} />} />
          <Route path="order_approval" element={<OrderApprovals />} />
          <Route path="ingram_failed_orders" element={<IngramFailedOrders />} />
          <Route path="ingram_mapping" element={<IngramMapping />} />
          <Route path="newsletters" element={<NewsletterListPage />} />
          <Route path="newsletters/:id" element={<NewsletterEditorPage />} />
          <Route path="blog-studio" element={<BlogStudioPage />} />
          <Route path="blog-studio/:id" element={<BlogDraftEditorPage />} />
          <Route
            path="monthly-digests"
            element={<WorkspaceMonthlyDigestPage />}
          />
          <Route path="email-analytics" element={<EmailAnalytics />} />
          <Route path="tracking/:trackingId" element={<TrackingDetails />} />
          <Route path="ref" element={<Ref userRole={userRole} />} />
          <Route path="source" element={<Source userRole={userRole} />} />
          {/* <Route path="home" element={<Home />} /> */}
          <Route path="website_apps" element={<WebsiteApps />} />
          <Route path="taxonomy" element={<TaxonomyPage />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
// https://app.easexpense.com/privacyPolicy
// https://app.easexpense.com/termsCondition
